import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Client } from './client';
import { SettingsService } from './settings.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { ErrorMessageComponent } from '../components/handler-server-respond/handler-server-respond.component';
import { MatSnackBar } from '@angular/material';

@Injectable()
export class OrderService {
  constructor(private http: HttpClient, private client: Client, private settingsService: SettingsService, private snackBar: MatSnackBar) {}
  acceptOrder(body) {
    return this.http.post(this.client.acceptOrderInsteadDriver(), body);
  }
  rejectOrder(body) {
    return this.http.post(this.client.rejectOrderInsteadDriver(), body);
  }

  getOrdersTariffs(obj) {
    return this.http.get(this.client.getAllTariffs(obj));
  }

  saveOrder(body) {
    return this.http.post(this.client.getOrderSaveUrl(), body);
  }

  cancelOrder(body) {
    return this.http.delete(this.client.getOrderCancelUrl(), { params: body });
  }

  updateOrder(body) {
    return this.http.post(this.client.getOrderUpdateUrl(), body);
  }

  countWay(body, useExternalEstimator) {
    return this.http.post(
      useExternalEstimator == 0 ? this.client.getEstimateCountPriceUrl() : 'operator/requests/estimate',
      body
    ).pipe(catchError( error => {
      if (error.error.error === '1000: [GOSRM][ERROR]: No route found') {
        this.handleServiceEvent('Ошибка. Нет маршрута между точками, обратитесь к картографам.', 7);
      }
      return of(error);
    }));
  }

  assignCab(obj) {
    const url =
      this.settingsService.settings[obj.service]['sending_round_enabled'] == '1'
        ? '/operator/requests/enqueue'
        : this.client.getOrderAssignCabUrl();
    return this.http.post(url, obj);
  }

  getCabs(obj) {
    return this.http.get(this.client.getCabsQuery(obj));
  }

  getRemoveOrderCabReason(trip_id) {
    return this.http.get(
      this.client.getRemoveOrderCabUrl({
        id: trip_id
      })
    );
  }

  getLogistCabOrder(requestId) {
    return this.http.get(
      this.client.getOrderCabRequest({
        id: requestId
      })
    );
  }

  getRemoveOrderReason(orderId) {
    return this.http.get(
      this.client.getRemoveOrderUrl({
        id: orderId
      })
    );
  }

  getHoldOrder(obj) {
    return this.http.put(this.client.getOrderHoldUrl(), obj);
  }

  getFare(obj) {
    return this.http.get(this.client.getFareUrl(obj));
  }

  updateFare(obj) {
    return this.http.post(this.client.getFareUrl(), obj);
  }

  getUnholdOrder(obj) {
    return this.http.put(this.client.getOrderUnholdUrl(), obj);
  }

  extendOrder(obj) {
    return this.http.post(this.client.getOrderExtendUrl(), obj);
  }

  getArrivedTrip(body) {
    return this.http.post(this.client.getTripArrivedUrl(), body);
  }

  getPickupTrip(body) {
    return this.http.post(this.client.getTripPickupUrl(), body);
  }

  private handleServiceEvent(msg, sec) {
    this.snackBar.openFromComponent(ErrorMessageComponent, {
      duration: sec * 1000,
      extraClasses: ['error-msg'],
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        op: msg,
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/order.service.ts